import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import Button from "../../Parts/Button";
import DialogModal from "../../common/DialogModal";

const styles = () => ({
  text: {
    marginBottom: "10px",
    textAlign: "left",
  },

  button: {
    background: "#F03A47",
    "&:hover::before": {
      backgroundColor: "#F03A47",
      opacity: 0.6,
    },
  },

  contentContainer: {
    padding: "50px 40px",
    margin: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "600px",
    boxSizing: "border-box",
    background: "#FFFFFF",
  },

  buttonContainer: {
    display: "inline-flex",
    width: "100%",
    justifyContent: "space-evenly",
    marginTop: "30px",
  },

  link: {
    color: "#1A65FF",
    textDecoration: "none",
  },
});

class SalesforceSyncWarningDialog extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (
      this.props.isPostingSalesforceSync &&
      !nextProps.isPostingSalesforceSync
    ) {
      this.props.toggleDialog();
    }
  }

  render() {
    const {
      classes,
      isOpen,
      toggleDialog,
      isSalesforceExeSettingEnabled,
    } = this.props;

    return (
      <DialogModal
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          contentContainer: classes.contentContainer,
        }}
      >
        {isSalesforceExeSettingEnabled ? (
          <div>
            <Typography variant="subheading" className={classes.text}>
              ここから同期を行うとSalesforce側でキャンペーンは作成されず、キーマンデータベース情報のみが指定したSalesforceオブジェクトに同期されます。同期を行いますか？
            </Typography>
            <Typography variant="subheading" className={classes.text}>
              ※注文情報をキャンペーンに同期したい場合、「注文履歴」より操作してください。
            </Typography>
          </div>
        ) : (
          <Typography variant="subheading" className={classes.text}>
            キーマンをSalesforceに同期するには、連携設定が必要です。「
            <Link
              to="/setting/integrations/salesforce"
              className={classes.link}
            >
              アカウント管理＞Salesforce連携
            </Link>
            」より設定してください。
          </Typography>
        )}

        <div className={classes.buttonContainer}>
          <Button
            handleClickButton={toggleDialog}
            text={isSalesforceExeSettingEnabled ? "キャンセル" : "閉じる"}
            type={isSalesforceExeSettingEnabled ? "ghost" : "default"}
            size="large"
          ></Button>
          {isSalesforceExeSettingEnabled && (
            <Button
              handleClickButton={this.props.handleSalesforceSync}
              text="同期する"
              loading={this.props.isPostingSalesforceSync}
              size="large"
            ></Button>
          )}
        </div>
      </DialogModal>
    );
  }
}

SalesforceSyncWarningDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  remove: PropTypes.func.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isDeleting: PropTypes.bool,
  isPostingSalesforceSync: PropTypes.bool,
  handleSalesforceSync: PropTypes.func.isRequired,
  isSalesforceExeSettingEnabled: PropTypes.bool,
};

export default withStyles(styles)(SalesforceSyncWarningDialog);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/SalesforceSyncWarningDialog.jsx